import styled from '@emotion/styled';
import './App.css';
import { Home } from './Pages/Home';

const Wrapper = styled.div`
  background-color: #000029;
  backdrop-filter: blur(50px) opacity(0.5);
`
function App() {
  return (
    <Wrapper>
      <Home />
    </Wrapper>
  );
}

export default App;
